import React from 'react';
import { Button, Columns, Column, Notification } from 'src/ui/mui-ui-kit';
import propTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function UiToast({ closeToast, message, type }) {
  const startIcon = type === 'success' ? 'check-circle' : 'exclamation-circle';

  return (
    <Notification isColor={type} className="ui-toast">
      <Columns isGapless isVCentered>
        <Column className="notification-content">
          <span className="icon is-medium">
            <FontAwesomeIcon icon={['fal', startIcon]} size="lg" />
          </span>
          {message}
        </Column>
        <Column isSize="narrow">
          <Button isColor={type} type="button" onClick={closeToast}>
            <span>Dismiss</span>
            <span className="icon is-medium">
              <FontAwesomeIcon icon={['fal', 'times-circle']} size="lg" />
            </span>
          </Button>
        </Column>
      </Columns>
    </Notification>
  );
}

UiToast.defaultProps = {
  type: 'info',
};

UiToast.propTypes = {
  message: propTypes.string.isRequired,
  type: propTypes.oneOf(['info', 'danger', 'warning', 'success']),
  closeToast: propTypes.func.isRequired,
};
